/**
 * Not found — the street does not go there. The split of the closed shop,
 * told for an address. The markup is the server's
 * (templates/site/sections/notfound/opening.html.twig).
 *
 * @module sections/notfound/opening
 */

import { animateSplitAway } from '../../components/split.js';

export const animate = animateSplitAway;
